import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'telefonoFormat' })
export class TelefonoFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) return '';
    const str = value.toString();
    // Formato argentino ejemplo: +54 3876 100200
    return `${str.substring(0, 2)} ${str.substring(2, 6)} ${str.substring(6)}`;
  }
}
